import { userTokenKey } from '@disco/constants/environment'
import Storage from 'disco-storage'
import { useCallback } from 'react'
import { connect } from 'react-redux'
import type { User } from 'types/user'
import {
  autologinUser,
  logoutUser,
} from '@disco/state-management/actions/UserActions'
import useEventListener from 'hooks/use-event-listener'
import { useInterval } from 'hooks/use-interval'

const mapStateToProps = state => ({
  user: state.user,
})

const TIMER_INTERVAL = 5000
type Props = {
  user: User
  autologinUser: typeof autologinUser
  logoutUser: typeof logoutUser
}

const SessionWatcher = ({ user, autologinUser, logoutUser }: Props) => {
  const handleStorageChange = useCallback(
    (e: StorageEvent) => {
      if (e.key !== userTokenKey) return

      if (e.newValue === null && user.loggedIn) {
        logoutUser()
      } else if (e.newValue && !user.loggedIn) {
        autologinUser()
      }
    },
    [user.loggedIn, logoutUser, autologinUser],
  )

  const _checkSessionTimer = useCallback(() => {
    if (!user.loggedIn) return
    const currentTime = new Date()
    const tokenInfo = Storage.getSync(userTokenKey)

    if (tokenInfo && tokenInfo.expires) {
      const sessionEpiryDate = new Date(tokenInfo.expires)
      if (sessionEpiryDate <= currentTime) logoutUser(true)
    }
  }, [user.loggedIn, logoutUser])

  useInterval(_checkSessionTimer, TIMER_INTERVAL)
  useEventListener('storage', handleStorageChange)
  return null
}

export default connect(mapStateToProps, {
  autologinUser,
  logoutUser,
})(SessionWatcher) as any
